// DuplicateWorkbench.jsx
import React from "react";

export default function DuplicateWorkbench({ items = [], onResolve }) {
  if (!items.length) {
    return (
      <section className="ce-duplicates" data-testid="ce-duplicates">
        <h2 style={{
          fontFamily: '"Cormorant Garamond", Georgia, serif',
          fontSize: "1.6rem", margin: "0 0 12px", fontWeight: 500,
        }}>
          Source Duplicate Review
        </h2>
        <p className="ce-duplicates__empty">
          No unresolved source duplicate hints. The catalog has no
          pending merge decisions at this time.
        </p>
      </section>
    );
  }

  return (
    <section className="ce-duplicates" data-testid="ce-duplicates">
      <h2 style={{
        fontFamily: '"Cormorant Garamond", Georgia, serif',
        fontSize: "1.6rem", margin: "0 0 12px", fontWeight: 500,
      }}>
        Source Duplicate Review
      </h2>
      <ol style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {items.map((it) => {
          const src = it.normalized_record || it.raw_record || {};
          const hints = it.duplicate_hints || [];
          return (
            <li key={it.id} style={{
              padding: "16px 0",
              borderBottom: "1px solid var(--li-border, #C7BDA6)",
            }} data-testid={`ce-duplicate-${it.id}`}>
              <div>
                <strong style={{ fontFamily: '"Cormorant Garamond", Georgia, serif' }}>
                  {src.title || "(untitled)"}
                </strong>
                <div style={{ fontSize: "0.85rem", color: "var(--li-text-secondary, #5C5450)" }}>
                  {src.composer || "Anonymous"} · staged row {it.row_number ?? "—"}
                </div>
              </div>
              <div style={{ marginTop: 8, fontSize: "0.85rem" }}>
                <div style={{
                  fontFamily: '"IBM Plex Mono", monospace',
                  fontSize: "0.65rem", textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  color: "var(--li-text-secondary, #5C5450)",
                }}>
                  Possible canonical matches
                </div>
                {hints.length === 0 ? (
                  <p style={{ margin: "4px 0" }}>None recorded.</p>
                ) : (
                  <ul style={{ margin: "4px 0 0 20px" }}>
                    {hints.map((h, i) => (
                      <li key={i}>{h.work_id} — score {h.score?.toFixed?.(2) ?? h.score}</li>
                    ))}
                  </ul>
                )}
              </div>
              <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button
                  className="ce-secondary"
                  onClick={() => onResolve?.(it, "distinct")}
                  data-testid={`ce-duplicate-distinct-${it.id}`}
                >
                  Distinct work
                </button>
                <button
                  className="ce-secondary"
                  onClick={() => onResolve?.(it, "merge")}
                  data-testid={`ce-duplicate-merge-${it.id}`}
                >
                  Merge as same work
                </button>
                <button
                  className="ce-secondary"
                  onClick={() => onResolve?.(it, "defer")}
                  data-testid={`ce-duplicate-defer-${it.id}`}
                >
                  Defer
                </button>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
